import React from 'react';
import useInView from './useInView';

const pillars = [
  'Customer Drive', 'Open Dialogue',
  'People & Teams', 'Hands-On Management',
  'Delivering Results', 'HSE Mindset',
];

const whyItems = [
  { num: '01', title: 'Indigenous & Registered', text: 'A 100% Nigerian firm with all current regulatory certifications — CAC, SCUML, ITF, EFCC, and Tax clearance on every project.' },
  { num: '02', title: 'Multi-Disciplinary', text: 'From boreholes to bridges, electrical to general contracting — one firm handles it all, cutting coordination costs and delays.' },
  { num: '03', title: 'Heavy Equipment', text: 'We operate concrete mixers, compactors, excavators, bulldozers, drill rigs, and heavy trucks — all maintained in-house.' },
  { num: '04', title: 'Quality, Cost & Time', text: 'Our management ethos is built around projects that totally satisfy clients in quality, cost, and timeline — no exceptions.' },
];

export default function Values() {
  const [leftRef, leftIn] = useInView();
  const [rightRef, rightIn] = useInView();
  const [whyRef, whyIn] = useInView();

  return (
    <>
      {/* Vision & Mission */}
      <section id="values" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        {/* Vision */}
        <div ref={leftRef} style={{
          background: 'var(--blue-deep)', padding: '7rem 5rem',
          opacity: leftIn ? 1 : 0, transform: leftIn ? 'none' : 'translateY(30px)',
          transition: 'all 0.8s ease',
        }}>
          <div className="section-label light">Our Direction</div>
          <h2 className="section-title" style={{ color: "#0d2144" }} style={{ marginBottom: '1.5rem' }}>
            Vision &<br /><span>Core Values</span>
          </h2>
          <p className="section-body light" style={{ marginBottom: '2.5rem' }}>
            To be the preferred partner for civil engineering and construction solutions in Nigeria — building infrastructure that transforms communities.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            {pillars.map((p, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'flex-start', gap: '0.6rem',
                padding: '0.85rem 1rem',
                border: '1px solid rgba(26,79,156,0.3)',
                transition: 'border-color 0.2s, background 0.2s',
                opacity: leftIn ? 1 : 0, transition: `opacity 0.4s ease ${0.3 + i * 0.08}s`,
                cursor: 'default', background: '#0d2144',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--blue)'; e.currentTarget.style.background = 'rgba(26,79,156,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(26,79,156,0.3)'; e.currentTarget.style.background = 'transparent'; }}>
                <div style={{ width: 8, height: 8, background: 'var(--blue)', flexShrink: 0, marginTop: '0.3rem' }} />
                <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.82rem', fontWeight: 600, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.07em', textTransform: 'uppercase' }}>{p}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Mission */}
        <div ref={rightRef} style={{
          background: 'white', padding: '7rem 5rem',
          opacity: rightIn ? 1 : 0, transform: rightIn ? 'none' : 'translateY(30px)',
          transition: 'all 0.8s ease 0.15s',
        }}>
          <div className="section-label">Our Purpose</div>
          <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>
            Mission &<br /><span>Commitment</span>
          </h2>
          <div style={{ borderLeft: '4px solid var(--blue)', paddingLeft: '1.5rem', background: 'var(--off-white)', padding: '1.8rem', marginBottom: '1.8rem' }}>
            <blockquote style={{ fontSize: '1.02rem', lineHeight: 1.78, color: 'var(--blue-deep)', fontStyle: 'italic', fontWeight: 300 }}>
              "The mission of Rigomich Integrated Company Limited is to provide superior quality general engineering construction services that are contracted, scheduled, engineered, and managed to create maximum value for our customers, owners, employees, and the community."
            </blockquote>
            <cite style={{ display: 'block', marginTop: '1rem', fontStyle: 'normal', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--blue)', fontFamily: "'Barlow Condensed', sans-serif" }}>
              — Rigomich Mission Statement
            </cite>
          </div>
          <p style={{ fontSize: '0.93rem', color: 'var(--grey)', lineHeight: 1.8 }}>
            Our deliveries are the sum of expertise and experience of 30 professionals. We actively attract individuals who understand our customers' needs and can produce and deliver the best solutions — respecting diversity and encouraging innovation.
          </p>
        </div>
      </section>

      {/* Why Us */}
      <section id="why" style={{ padding: '7rem 0', background: '#ffffff' }}>
        <div className="section-wrap">
          <div ref={whyRef} style={{
            textAlign: 'center', maxWidth: 560, margin: '0 auto 3.5rem',
            opacity: whyIn ? 1 : 0, transform: whyIn ? 'none' : 'translateY(24px)',
            transition: 'all 0.7s ease',
          }}>
            <div className="section-label" style={{ justifyContent: "center", color: "#0d2144" }}>Why Rigomich</div>
            <h2 className="section-title" style={{ color: "#0d2144" }}>Built on <span>Trust</span>,<br />Driven by Results</h2>
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
            border: '1px solid rgba(255,255,255,0.3)',
          }}>
            {whyItems.map((w, i) => (
              <div key={i} style={{
                padding: '2.5rem 2rem',
                borderRight: i < 3 ? '1px solid rgba(255,255,255,0.3)' : 'none',
                opacity: whyIn ? 1 : 0, transform: whyIn ? 'none' : 'translateY(20px)',
                transition: `all 0.6s ease ${0.1 + i * 0.1}s`,
                cursor: 'default', background: '#0d2144',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(26,79,156,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#0d2144'; }}>
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '3.5rem', color: '#7aaef0', opacity: 0.4, lineHeight: 1, marginBottom: '1rem' }}>{w.num}</div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'white', marginBottom: '0.8rem' }}>{w.title}</div>
                <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.65, fontWeight: 300 }}>{w.text}</p>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @media (max-width: 900px) {
            #values { grid-template-columns: 1fr !important; }
            #values > div { padding: 4rem 1.5rem !important; }
            #why .section-wrap > div:last-child { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 600px) {
            #why .section-wrap > div:last-child { grid-template-columns: 1fr !important; }
          }
        `}</style>
      </section>
    </>
  );
}
